import { render } from "./BoldClock.vue?vue&type=template&id=ba309d34&scoped=true"
import script from "./BoldClock.vue?vue&type=script&lang=js"
export * from "./BoldClock.vue?vue&type=script&lang=js"

import "./BoldClock.vue?vue&type=style&index=0&id=ba309d34&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba309d34"]])

export default __exports__